import React from "react";
import NoDataFound from "../../common/NoDataFound";
import { teamLeagueInfoUrl, titleToSlug } from "../../../utils/generalLiveCenter";

const TopScorers = ({
  data,
  dictionary,
  websiteBaseUrl,
  dataPath,
  dataClient,
  sport = "football",
}) => {
  return (
    <div className="global_table striped offense_tbl top_score_wrp">
      {data?.length ? (
        <>
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Players</th>
                <th>P</th>
                <th>G</th>
              </tr>
            </thead>
            <tbody>
              <>
                {data?.slice(0, 20)?.map((i, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>
                      <a
                        href={teamLeagueInfoUrl({
                          dataClient,
                          websiteBaseUrl,
                          dataPath,
                          category: "player",
                          sport,
                          name: titleToSlug(i?.pn),
                          id: i?.player_id,
                        })}
                      >
                        <strong className="cr_name">{i?.pn}</strong>
                      </a>
                    </td>
                    <td>{i?.pc}</td>
                    <td>{i?.gs}</td>
                  </tr>
                ))}
              </>
            </tbody>
          </table>
          <div className="bottom_tr">
            <ul className="item_list">
              <li>
                <span className="symbol">P</span>
                <span className="full_form">Game Play</span>
              </li>{" "}
              <li>
                <span className="symbol">G</span>
                <span className="full_form">Goal Scored</span>
              </li>
              <li>
                <span className="symbol">RK</span>
                <span className="full_form">Rankings</span>
              </li>
              <li>
                <span className="symbol">A</span>
                <span className="full_form">Assists</span>
              </li>
            </ul>
          </div>
        </>
      ) : (
        <NoDataFound />
      )}
    </div>
  );
};

export default TopScorers;
